var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{staticStyle:{"width":"110%"},attrs:{"type":"bar","options":_vm.visitorBarChartConfig,"series":[{ data: _vm.visitorBarChartSeries }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }